// frontend/polaris/src/api/auth/forgot-password.ts
import { useMutation, useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/lib/axios';

export interface RequestResetInput {
  email: string;
  language?: string;
}

export interface ResetPasswordInput {
  password: string;
  language?: string;
}

export interface ValidateTokenResponse {
  valid: boolean;
  email?: string;
}

export async function requestPasswordReset(input: RequestResetInput): Promise<void> {
  await axiosInstance.post('/api/auth/forgot-password', input);
}

export async function validateResetToken(token: string): Promise<ValidateTokenResponse> {
  const response = await axiosInstance.get(`/api/auth/reset-password/${token}/validate`);
  return response.data;
}

export async function resetPassword(token: string, input: ResetPasswordInput): Promise<void> {
  await axiosInstance.post(`/api/auth/reset-password/${token}`, input);
}

export function useRequestPasswordReset() {
  return useMutation({
    mutationFn: requestPasswordReset,
  });
}

export function useValidateResetToken(token: string) {
  return useQuery({
    queryKey: ['reset-token', token],
    queryFn: () => validateResetToken(token),
    enabled: !!token,
    retry: false,
    staleTime: Infinity,
  });
}

export function useResetPassword(token: string) {
  return useMutation({
    mutationFn: (input: ResetPasswordInput) => resetPassword(token, input),
  });
}
